document.addEventListener('DOMContentLoaded', function (){
    const showPopupLinks = document.querySelectorAll('a[href="#show_popup"]');

    showPopupLinks.forEach(function (link) {
        link.addEventListener('click', function (){
            const popup = document.querySelector('.newsletter-popup-custom');
            popup.classList.add('is-active')

            popup.querySelector('.popup-close-icon-button').addEventListener('click', function (){
                popup.classList.remove('is-active')
            })
        })
    })
})
